function generateUniqueId(): string {
  const timestamp = new Date().getTime();
  const randomPart = Math.random().toString(36).substring(2, 15);
  return `${timestamp}-${randomPart}`;
}

type Process = () => Promise<any>;

interface QueueItem {
  id: string;
  process: Process;
}

enum STATUSES {
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
}

class ProcessQueueManager {
  private queue: QueueItem[];
  private isProcessing: boolean;
  private results: Map<string, { status: STATUSES.RESOLVED | STATUSES.REJECTED, result?: any, error?: any }>;

  constructor() {
    this.queue = [];
    this.isProcessing = false;
    this.results = new Map();
  }

  enqueueProcess(process: Process): string {
    const id = generateUniqueId();
    this.queue.push({ id, process });
    if (!this.isProcessing) {
      this.processQueue();
    }
    return id;
  }

  private async processQueue(): Promise<void> {
    this.isProcessing = true;
    while (this.queue.length > 0) {
      const { id, process } = this.queue.shift()!;
      try {
        // TODO: it would be nice to log this errors to show it only for development environments
        // console.log(`Processing item with ID: ${id}`);
        const result = await process();
        this.results.set(id, { status: STATUSES.RESOLVED, result });
      } catch (error) {
        // TODO: it would be nice to log this errors to show it only for development environments
        // console.error(`Process with ID ${id} failed:`, error);
        this.results.set(id, { status: STATUSES.REJECTED, error });
      }
    }
    this.isProcessing = false;
  }

  waitForProcessCompletion(processId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const checkResult = () => {
        if (this.results.has(processId)) {
          const result = this.results.get(processId)!;
          if (result.status === STATUSES.RESOLVED) {
            resolve(result.result);
          } else {
            reject(result.error);
          }
        } else {
          setTimeout(checkResult, 50); // Check again after a short delay
        }
      };
      checkResult();
    });
  }
}

export default ProcessQueueManager;
